import { UsageTransfer } from '@qsightpbi-integration/sdk';

export type ReportFilterContext = {
    departmentId: string[];
    hospitalId: string[];
    expiringBucket: 7 | 30 | 60 | 90 | 180;
    consigned: 0 | 1 | 2; // 0 = Owned, 1 = Consigned, 2 = Both
    orderBy: string;
    queryBuilder: any[];
};

function getKey(base: string, consigned: number): string | null {
    switch (consigned) {
        case 0: return `${base}Owned`;
        case 1: return `${base}Consigned`;
        case 2: return base;
        default: return null;
    }
}

function extractNumericValue(response: UsageTransfer.Props, key: string | null): number | null {
    if (!key) return null;
    const value = response[key as keyof UsageTransfer.Props];
    if (typeof value === 'number') return value;
    if (typeof value === 'string' && !isNaN(Number(value))) return Number(value);
    return null;
}

export function getValueToExpireFromUsageTransfer(
    response: UsageTransfer.Props,
    context: ReportFilterContext
): number | null {
    const baseKey = `valueToExpire${context.expiringBucket}d`;
    const key = getKey(baseKey, context.consigned);
    return extractNumericValue(response, key);
}

export function getTransferFromQuantityFromUsageTransfer(
    response: UsageTransfer.Props,
    context: ReportFilterContext
): number | null {
    const baseKey = `transferFromQuantity${context.expiringBucket}d`;
    const key = getKey(baseKey, context.consigned);
    return extractNumericValue(response, key);
}

export function getQuantityLastYearValueFromUsageTransfer(
    response: UsageTransfer.Props,
    context: ReportFilterContext
): number | null {
    const key = getKey('quantityLastYear', context.consigned);
    return extractNumericValue(response, key);
}

export function getDepartmentQtyFromUsageTransfer(
    response: UsageTransfer.Props,
    context: ReportFilterContext
): number | null {
    const key = getKey('departmentQty', context.consigned);
    return extractNumericValue(response, key);
}

